export default __webpack_public_path__ + "static/media/incubator-bg@2x.fe33f0e8.webp";